import { useState } from "react"
import { Modal, TableCustom } from "../../../../../components/common"
import {TIPS} from "../../../../../consts/tips";

const AddFiltroModal = ({ filtros, onConfirm, onCancel }) => {
    const [items, setItems] = useState(filtros.map(x => ({ ...x, selected: false })))

    const onItemsSelected = (selected) => {
        setItems(prev => prev.map(item => {
            const update = selected.find(x => x.id === item.id)
            return update ? { ...item, selected: update.selected } : item
        }))
    }

    const onClickAccept = () => {
        onConfirm(items.filter(x => x.selected))
    }

    return (
        <Modal
            onEscape={onCancel}
            show
            title="Filtros disponibles"
            tipName={TIPS.NAME.MODALS.FILTROS_DISPONIBLES_MODAL}
            body={
                <div className="row">
                    <TableCustom
                        className='TableCustomBase'
                        columns={[
                            { Header: 'Nombre', accessor: 'nombre', width: '95%', },
                        ]}
                        data={items}
                        useSelectedField
                        onItemsSelected={onItemsSelected}
                    />
                </div>
            }
            footer={ <>
            <div className="width-100p disp-b">
                <button className="btn back-button" data-dismiss="modal" onClick={onCancel}>Volver</button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={onClickAccept}>Aceptar</button>
                
            </div>
            </>}
        />
    )
}

export default AddFiltroModal
